import { Popup } from 'antd-mobile'
import styles from './AigcPromotionDrawer.module.less'
import { Trans, useTranslation } from 'react-i18next'
import AIcon from '@/components/A/AIcon/AIcon'
import { commonUtils } from '@/helpers/commonUtils'

interface Props {
  visible: boolean
  onClose: () => void
  onRegister: () => void
}

function AigcPromotionDrawer(props: Props) {
  const { t } = useTranslation()

  return (
    <Popup
      bodyClassName={styles.popup}
      visible={props.visible}
      position='bottom'
      onMaskClick={props.onClose}
    >
      <div className={styles.aigcPromotionDrawer} data-testid='aigc-promotion-drawer'>
        <button className={styles.closeBtn} data-testid='aigc-promotion-drawer-close-btn' onClick={props.onClose}>
          <AIcon type='icon-line-global_close1' />
        </button>
        <img
          className={styles.visualBg}
          src={commonUtils.getImagePath('homePage/aigc-promotion-mobile.png')}
          alt=''
        />
        <div className={styles.titleRow}>
          <img
            className={styles.titleIcon}
            src={commonUtils.getImagePath('homePage/aigc-promotion-icon-1.png')}
            alt=''
          />
          <p className={styles.title}>{t('modals.aigcPromotionModal.title')}</p>
        </div>
        <p className={styles.subTitle}>
          <Trans
            i18nKey='modals.aigcPromotionModal.subTitle'
            components={{ tmp: <span className={styles.highlightFive} /> }}
          />
        </p>
        <div className={styles.descBox}>
          <p className={styles.desc}>{t('modals.aigcPromotionModal.desc1')}</p>
          <p className={styles.desc}>{t('modals.aigcPromotionModal.desc2')}</p>
        </div>
        <button className={styles.actionBtn} data-testid='aigc-promotion-drawer-register-btn' onClick={props.onRegister}>
          <span className={styles.actionIcon}>🚀</span>
          {t('modals.aigcPromotionModal.registerBtn')}
        </button>
        <p className={styles.tips}>{t('modals.aigcPromotionModal.tip')}</p>
      </div>
    </Popup>
  )
}

export default AigcPromotionDrawer
